import { Chip } from '@mui/material'

const DISCREPANCY_MAP = {
  NONE: { label: 'No Discrepancy', color: '#16a34a', bg: '#dcfce7' },
  LOW: { label: 'Low (<15%)', color: '#a16207', bg: '#fef9c3' },
  MEDIUM: { label: 'Medium (15–30%)', color: '#c2410c', bg: '#ffedd5' },
  HIGH: { label: 'High (>30%)', color: '#b91c1c', bg: '#fee2e2' },
}

export function DiscrepancyBadge({ level }) {
  if (!level) {
    return (
      <Chip
        size='small'
        label='Pending MIS'
        sx={{ height: 22, fontSize: 11, bgcolor: '#f3f4f6', color: '#6b7280' }}
      />
    )
  }
  const cfg = DISCREPANCY_MAP[level] || DISCREPANCY_MAP.NONE
  return (
    <Chip
      size='small'
      label={cfg.label}
      sx={{ height: 22, fontSize: 11, bgcolor: cfg.bg, color: cfg.color, fontWeight: 600 }}
    />
  )
}

const STAGE_MAP = {
  BOOKING: { label: 'Booking', color: '#1e40af', bg: '#dbeafe' },
  MIS_UPLOADED: { label: 'MIS Uploaded', color: '#a16207', bg: '#fef3c7' },
  BILLED: { label: 'Billed', color: '#15803d', bg: '#dcfce7' },
}

export function StageBadge({ stage }) {
  const cfg = STAGE_MAP[stage] || { label: stage || '—', color: '#6b7280', bg: '#f3f4f6' }
  return (
    <Chip
      size='small'
      label={cfg.label}
      sx={{ height: 22, fontSize: 11, bgcolor: cfg.bg, color: cfg.color, fontWeight: 600 }}
    />
  )
}
